export default {"src":"/_next/static/media/Clock-green.6d4a0398.svg","height":1600,"width":1600};